document.addEventListener('DOMContentLoaded', function () {
  console.log("DOM fully loaded and parsed");

  let observer;

  // Function to enable the checkout button
  function enableCheckoutButton() {
    const checkoutButton = document.getElementById('checkout-button');
    if (checkoutButton) {
      checkoutButton.disabled = false;
      checkoutButton.classList.remove('disabled');
    }
  }

  // Function to handle payment method change
  // async function handlePaymentMethodChange() {
  //   console.log('Payment method changed - cart drawer');
  //   const paymentMethod = document.getElementById('payment-method').value;
  //   const loader = document.getElementById('loader');
  //   const paymentMethodSelect = document.getElementById('payment-method');
  //   const variantIdKey = 'surchargeVariantId'; // Key for storing variant ID in local storage

  //   const showLoader = () => {
  //     loader.style.display = 'block';
  //     paymentMethodSelect.disabled = true;
  //   };

  //   const hideLoader = () => {
  //     loader.style.display = 'none';
  //     paymentMethodSelect.disabled = false;
  //   };

  //   try {
  //     showLoader();
  //     console.log("Processing payment method change");
  //     const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
  //     if (!cartResponse.ok) throw new Error('Failed to fetch cart');

  //     const cartData = await cartResponse.json();
  //     const surchargeItems = cartData.items.filter(item => item.product_title === 'Credit Card Fee');

  //     console.log(surchargeItems, "surchargeItems");

  //     // Remove existing surcharge items from the cart
  //     await Promise.all(surchargeItems.map(item =>
  //       fetch(`${window.Shopify.routes.root}cart/change.js`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify({
  //           id: item.key,
  //           quantity: 0
  //         })
  //       })
  //     ));

  //     if (paymentMethod === 'credit-card') {
  //       console.log("Processing credit card payment");
  //       const totalPriceElement = document.getElementById('total_price');
    
  //       // Extract the value and remove any non-numeric characters
  //       const totalPriceStr = totalPriceElement.value;
  //       const totalPrice = parseFloat(totalPriceStr.replace(/[^0-9.-]/g, ''));
        
  //       const charge = (window.surchargePercentage * totalPrice) / 100;
  //       const response = await fetch(`https://goshopified.com/jad-b-2.myshopify.com/create.php?price=${encodeURIComponent(charge.toFixed(2))}`);
  //       if (!response.ok) throw new Error('Failed to fetch variant_id');

  //       const data = await response.json();
  //       console.log(data.variant_id);
  //       if (!data.variant_id) throw new Error('Variant ID not found');

  //       // Store the variant ID in local storage
  //       localStorage.setItem(variantIdKey, data.variant_id);

  //       const formData = {
  //         items: [{
  //           id: data.variant_id,
  //           quantity: 1
  //         }]
  //       };

  //       const addToCartResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json'
  //         },
  //         body: JSON.stringify(formData)
  //       });

  //       if (!addToCartResponse.ok) throw new Error('Failed to add to cart');

  //       console.log('Cart Add Response:', await addToCartResponse.json());
  //     }

  //     // Enable the checkout button when a payment method is selected
  //     enableCheckoutButton();

  //   } catch (error) {
  //     console.error('Error:', error);
  //   } finally {
  //     hideLoader();
  //   }
  // }

  async function handlePaymentMethodChange() {
  console.log('Payment method changed - cart page');

  const paymentMethod = document.getElementById('payment-method').value;
  console.log('Selected Payment Method:', paymentMethod);

  const loader = document.getElementById('loader');
  const paymentMethodSelect = document.getElementById('payment-method');
  const variantIdKey = 'surchargeVariantId'; // Local storage key

  const showLoader = () => {
    if (loader) loader.style.display = 'block';
    paymentMethodSelect.disabled = true;
  };

  const hideLoader = () => {
    if (loader) loader.style.display = 'none';
    paymentMethodSelect.disabled = false;
  };

  try {
    showLoader();

    // === Fetch cart data ===
    const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (!cartResponse.ok) throw new Error('Failed to fetch cart');
    const cartData = await cartResponse.json();
    console.log('cartData', cartData);

    // === Remove any existing surcharge items ===
    const surchargeItems = cartData.items.filter(
      (item) => item.product_title.includes('Fee')
    );

    await Promise.all(
      surchargeItems.map((item) =>
        fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 }),
        })
      )
    );
    console.log('surge', surchargeItems);

    // === Get total price from cart ===
    const totalPriceElement = document.getElementById('total_price');
    if (!totalPriceElement) throw new Error('Total price element not found');
    const totalPriceStr = totalPriceElement.value;
    const totalPrice = parseFloat(totalPriceStr.replace(/[^0-9.-]/g, ''));

    let surchargePercentage = 0;
    let surchargeName = '';

    // === Switch payment method logic ===
    switch (paymentMethod.toLowerCase()) {
      case 'credit card':
        surchargePercentage = window.surchargePercentage; // Example: 2.5% for credit cards
        surchargeName = 'Credit Card Fee';
        break;

      case 'whish pay':
        surchargePercentage = 2.0;
        surchargeName = 'Wishpay Fee';
        break;

      /*case 'paypal':
        surchargePercentage = 2.0; // Example: 2% for PayPal
        surchargeName = 'PayPal Fee';
        break;

      case 'shop_pay':
        surchargePercentage = 1.5; // Example: 1.5% for Shop Pay
        surchargeName = 'Shop Pay Fee';
        break;*/

      default:
        console.log('No surcharge applied for this payment method.');
        hideLoader();
        enableCheckoutButton();
        /*
        setTimeout(() => {
          window.location.href = `https://${window.Shopify.shop}/checkout`;
        }, 500);
        */
        return; // Exit early if no surcharge
    }
    console.log('surchargePercentage', surchargePercentage);

    // === Calculate surcharge ===
    const charge = (surchargePercentage * totalPrice) / 100;
    console.log(`${surchargeName} - ${surchargePercentage}% → ${charge.toFixed(2)}`);

    // === Create surcharge variant via PHP endpoint ===
    const response = await fetch(
      `https://goshopified.com/jad-b-2.myshopify.com/create.php?price=${encodeURIComponent(
        charge.toFixed(2)
      )}&title=${encodeURIComponent(surchargeName)}`
    );
    if (!response.ok) throw new Error('Failed to fetch variant_id');

    const data = await response.json();
    if (!data.variant_id) throw new Error('Variant ID not found');

    console.log(data, "data");

    localStorage.setItem(variantIdKey, data.variant_id);

    // === Add surcharge item to cart ===
    const addToCartResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: data.variant_id, quantity: 1 }],
      }),
    });

    if (!addToCartResponse.ok) throw new Error('Failed to add surcharge to cart');
    console.log('Surcharge added:', await addToCartResponse.json());
    enableCheckoutButton();

  } catch (error) {
    console.error('Error:', error);
  } finally {
    hideLoader();
    // setTimeout(() => {
    //   window.location.href = `https://${window.Shopify.shop}/checkout`;
    // }, 1000);
  }
}

  // Initialize payment method listener
  function initPaymentMethodListener() {
    const paymentMethodSelect = document.getElementById('payment-method');
    if (paymentMethodSelect) {
      console.log('Initializing payment method listener');
      paymentMethodSelect.addEventListener('change', handlePaymentMethodChange);
    } else {
      console.log('Payment method select element not found. Retrying...');
    }
  }

  // Function to disable removal of surcharge product from the cart drawer
  function disableSurchargeRemoval() {
    const variantId = localStorage.getItem('surchargeVariantId');
    if (variantId) {
      // Find and disable the remove button for the surcharge product in the cart drawer
      document.querySelectorAll(`.cart-remove-button[data-variant-id="${variantId}"]`).forEach(button => {
        button.disabled = true;
        button.classList.add('disabled');
      });
    }
  }

  // Function to observe cart drawer for changes
  function observeCartDrawer() {
    const drawer = document.querySelector('.cart-drawer'); // Adjust selector if needed
    if (drawer) {
      if (observer) {
        observer.disconnect(); // Disconnect any existing observer
      }
      observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          console.log('Mutation observed:', mutation);
          if (mutation.type === 'childList' || mutation.attributeName === 'class') {
            console.log('Cart drawer content changed');
            initPaymentMethodListener();
            disableSurchargeRemoval();
          }
        });
      });

      observer.observe(drawer, { childList: true, attributes: true, subtree: true });
    } else {
      console.log('Cart drawer not found. Retrying...');
      setTimeout(observeCartDrawer, 500); // Retry after a delay if drawer is not found
    }
  }

  // Handle page load and reinitialize drawer if needed
  function reinitializeDrawer() {
    console.log('Reinitializing drawer functionality');
    observeCartDrawer();
  }

  window.addEventListener('load', reinitializeDrawer);
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) { // Only trigger if the page was loaded from cache
      reinitializeDrawer();
    }
  });

  // Start observing the cart drawer
  observeCartDrawer();

  // Ensure we initialize the event listener when the script first loads
  initPaymentMethodListener();
});
